import React, { Component } from 'react'
import styled from 'styled-components'
import t from 'prop-types'

const Wrapper = styled.div`
  overflow-x: hidden;
  white-space: nowrap;
`
const Input = styled.input.attrs({
  type: 'radio',
})`
  margin-right: 5px;
  width: 10px;
`
const Label = styled.label`
  font-weight: ${({ bold }) => bold ? 'bold' : 'normal'};
`
const Item = styled.div`
`

class RadioList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selection: props.selection,
    }
  }

  handleItemClick (id) {
    if (!this.props.onChange) return

    this.setState({
      selection: id,
    })
    this.props.onChange(id)
  }

  render () {
    const {
      items,
      onChange,
    } = this.props

    const { selection } = this.state

    return (
      <Wrapper>
        { items.map(({ id, label }) => {
          const itemSelected = selection === id

          return (
            <Item
              key={id}
              onClick={() => this.handleItemClick(id)}
            >
              <Input
                checked={itemSelected}
                disabled={!onChange}
              />
              <Label bold={itemSelected}>{label}</Label>
            </Item>
          )
        })}
      </Wrapper>
    )
  }
}

RadioList.propTypes = {
  items: t.array.isRequired,
  onChange: t.func,
  selection: t.number,
}

export default RadioList



// WEBPACK FOOTER //
// ./src/components/UI/Form/RadioList.jsx